/**
 * Query Key factory for all prescription queries.
 *
 * @module Prescription
 */

import { Pagination } from "@customTypes/index";


export const prescriptionQKeys = {
  all: () => ["prescriptions"] as const,

  allWithFilters: (filters: {
    pagination?: Partial<Pagination>;
    userId?: string;
  }) => [...prescriptionQKeys.all(), { ...filters }] as const,

  patients: () => [...prescriptionQKeys.all(), "patient"] as const,

  patient: (patientId: string) =>
    [...prescriptionQKeys.patients(), patientId] as const,

  patientWithFilters: (
    patientId: string,
    filters: {
      pagination?: Partial<Pagination>;
      withFilesOnly?: boolean;
      fastConsultationOnly?: boolean;
      search?: string;
      consultationId?: string;
    }
  ) => [...prescriptionQKeys.patient(patientId), { ...filters }] as const,

  singlePrescriptions: () =>
    [...prescriptionQKeys.all(), "singlePrescription"] as const,

  singlePrescription: (prescriptionId: string) =>
    [...prescriptionQKeys.singlePrescriptions(), prescriptionId] as const,

  consultations: () => [...prescriptionQKeys.all(), "consultation"] as const,

  consultation: (consultationId: string) =>
    [...prescriptionQKeys.consultations(), consultationId] as const,

  medications: () => [...prescriptionQKeys.all(), "medication"] as const,

  medication: (prescriptionId: string) =>
    [...prescriptionQKeys.medications(), prescriptionId] as const,

  medicationWithFilters: (
    prescriptionId: string,
    filters: {
      pagination?: Partial<Pagination>;
      search?: string;
    }
  ) =>
    [...prescriptionQKeys.medication(prescriptionId), { ...filters }] as const,
};
